/*!
 * smooth-scroll
 * use : smooth-scroll.polyfills.min.js
 * https://github.com/cferdinandi/smooth-scroll
 */

var scroll = new SmoothScroll('a[href*="#"]');
